import styled from "styled-components"

export default function ProductInfoSection({ children }) {
  return <InfoSection>{children}</InfoSection>
}

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
